export const LIKED_DATA="LIKED_DATA";
export const WATCHLATER_DATA="WATCHLATER_DATA";
export const PLAYLIST_DATA="PLAYLIST_DATA";
export const HISTORY_DATA="HISTORY_DATA";
export const SINGLE_PLAYLIST_DATA="SINGLE_PLAYLIST_DATA";
export const CLEAR_DATA="CLEAR_DATA";
export const SEARCH="SEARCH";
export const CLEAR_SEARCH="CLEAR_SEARCH";
export const SINGLE_PLAYLIST="SINGLE_PLAYLIST";